import './Checklist.css';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { checklist } from './api';

function Checklist() {
  const { bateauId } = useParams();
  const navigate = useNavigate();
  const [checklists, setChecklists] = useState([]);
  const [currentChecklist, setCurrentChecklist] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadChecklists();
  }, [bateauId]);

  const loadChecklists = async () => {
    try {
      const response = await checklist.getByBateau(bateauId);
      setChecklists(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const handleCreateChecklist = async () => {
    try {
      const response = await checklist.create(bateauId);
      setCurrentChecklist(response.data);
      loadChecklists();
    } catch (err) {
      alert('Erreur lors de la création');
    }
  };

  const handleToggleItem = async (itemId) => {
    if (!currentChecklist) return;
    
    const updatedItems = currentChecklist.items.map(item =>
      item.id === itemId ? { ...item, checked: !item.checked } : item
    );
    
    const allChecked = updatedItems.every(item => item.checked);
    
    try {
      const response = await checklist.update(currentChecklist.id, updatedItems, allChecked);
      setCurrentChecklist(response.data);
      loadChecklists();
    } catch (err) {
      alert('Erreur lors de la mise à jour');
    }
  };

  const handleSelectChecklist = (cl) => {
    setCurrentChecklist(cl);
  };

  if (loading) {
    return (
      <div className="checklist-page">
        <div style={{ textAlign: 'center', padding: '50px' }}>Chargement...</div>
      </div>
    );
  }

  return (
    <div className="checklist-page">
      <header className="checklist-header">
        <h1>✅ Checklist Pré-Navigation</h1>
      </header>

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <button onClick={handleCreateChecklist} className="btn btn-primary">
          ➕ Nouvelle Checklist
        </button>
      </div>

      {!currentChecklist && checklists.length === 0 && (
        <div style={{
          background: 'white',
          padding: '40px',
          borderRadius: '16px',
          textAlign: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <p style={{ fontSize: '18px', color: '#666' }}>
            Aucune checklist créée
          </p>
          <p style={{ color: '#999' }}>
            Cliquez sur "Nouvelle Checklist" pour commencer
          </p>
        </div>
      )}

      {checklists.length > 0 && !currentChecklist && (
        <div>
          <h2 style={{ color: '#667eea', marginBottom: '15px' }}>📚 Historique</h2>
          <div style={{ display: 'grid', gap: '15px' }}>
            {checklists.map((cl) => (
              <div
                key={cl.id}
                onClick={() => handleSelectChecklist(cl)}
                style={{
                  background: 'white',
                  padding: '20px',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  border: '2px solid transparent',
                  transition: 'all 0.3s',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#667eea';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <strong style={{ fontSize: '1.1rem' }}>
                      {new Date(cl.date).toLocaleDateString('fr-FR')}
                    </strong>
                    {' à '}
                    {new Date(cl.date).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                  <div>
                    {cl.completed ? (
                      <span style={{ color: '#27ae60', fontWeight: 'bold', fontSize: '1.1rem' }}>
                        ✅ Complète
                      </span>
                    ) : (
                      <span style={{ color: '#e67e22', fontWeight: 'bold', fontSize: '1.1rem' }}>
                        ⏳ En cours
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {currentChecklist && (
        <div style={{
          background: 'white',
          padding: '30px',
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <div style={{ 
            marginBottom: '20px', 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center' 
          }}>
            <div>
              <h2 style={{ margin: 0, color: '#667eea' }}>
                {new Date(currentChecklist.date).toLocaleDateString('fr-FR')}
              </h2>
              <p style={{ margin: '5px 0 0 0', color: '#666' }}>
                {new Date(currentChecklist.date).toLocaleTimeString('fr-FR', { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </p>
            </div>
            <button
              onClick={() => setCurrentChecklist(null)}
              className="btn btn-secondary"
            >
              Fermer
            </button>
          </div>

          {currentChecklist.completed && (
            <div style={{
              background: '#d4edda',
              color: '#155724',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '20px',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              ✅ Checklist complète - Bon voyage !
            </div>
          )}

          <div style={{ display: 'grid', gap: '12px' }}>
            {currentChecklist.items.map((item) => (
              <div
                key={item.id}
                onClick={() => handleToggleItem(item.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '15px',
                  background: item.checked ? '#d4edda' : '#f8f9fa',
                  border: `2px solid ${item.checked ? '#28a745' : '#dee2e6'}`,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
              >
                <div style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '4px',
                  border: '2px solid #667eea',
                  background: item.checked ? '#667eea' : 'white',
                  marginRight: '15px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  color: 'white'
                }}>
                  {item.checked && '✓'}
                </div>
                <span style={{
                  fontSize: '16px',
                  color: item.checked ? '#155724' : '#333',
                  fontWeight: item.checked ? 'bold' : 'normal'
                }}>
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="back-button">
        <button onClick={() => navigate('/bateaux')} className="btn btn-secondary">
          ← Retour aux bateaux
        </button>
      </div>
    </div>
  );
}

export default Checklist;